import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS, API_BASE_URL_DOCS } from "../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";

const ProgramFiles = () => {
  const { authFetch } = useContext(AuthContext);

  const [programas, setProgramas] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [files, setFiles] = useState([]);

  const [areaUser, setAreaUser] = useState(null);
  const [role, setRole] = useState("");

  const [showModal, setShowModal] = useState(false);

  const [newFile, setNewFile] = useState({
    name: "",
    file: null
  });

  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");

  // =========================
  // NAVEGACIÓN ÁREA 1
  // =========================

  // Categoría seleccionada:
  // 1 = Jurídico
  // 2 = Financiero
  // 3 = Técnico
  // 4 = Administrativo
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Subcategoría de Técnico:
  // 1 = Planeación
  // 2 = Ejecución
  // 3 = Evaluación
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);

  // =========================
  // FILTROS DE BUSQUEDA
  // =========================
  const [searchName, setSearchName] = useState("");
  const [searchDate, setSearchDate] = useState("");

  // =========================
  // BUSCADOR PROGRAMAS
  // =========================
  const [searchProgram, setSearchProgram] = useState("");

  // =========================
  // USER
  // =========================
  const fetchUser = useCallback(async () => {
    const data = await authFetch(ENDPOINTS.me);

    if (data.success) {
      setAreaUser(data.user.area);
      setRole(data.user.role);
    }
  }, [authFetch]);

  // =========================
  // PROGRAMAS
  // =========================
  const fetchProgramas = useCallback(async () => {
    const data = await authFetch(ENDPOINTS.get_programasAll);

    if (data.success) {
      setProgramas(data.data || []);
    }
  }, [authFetch]);

  // =========================
  // FILES POR PROGRAMA
  // =========================
  const fetchFiles = async (programId) => {
    const data = await authFetch(
      `${ENDPOINTS.get_program_file}?program=${programId}`
    );

    if (data.success) {
      setFiles(data.data || []);
    }
  };

  // =========================
  // INIT
  // =========================
  useEffect(() => {
    fetchUser();
    fetchProgramas();
  }, [fetchUser, fetchProgramas]);

  // =========================
  // FILTRO POR AREA
  // =========================
  const rolesFullAccess = [
    "SuperAdmin",
    "Director General",
    "Auditor"
  ];

  const programasFiltrados =
    rolesFullAccess.includes(role)
      ? programas
      : programas.filter(
          (p) => Number(p.area) === Number(areaUser)
        );

  // =========================
  // PROGRAMA BUSQUEDA
  // =========================
  const programasBusqueda = programasFiltrados.filter((prog) =>
    prog.program_name
      .toLowerCase()
      .includes(searchProgram.toLowerCase())
  );

  // =========================
  // ABRIR PROGRAMA
  // =========================
  const handleOpenProgram = (prog) => {
    setSelectedProgram(prog);

    // Reiniciar navegación
    setSelectedCategory(null);
    setSelectedSubcategory(null);

    // Limpiar filtros de archivos
    setSearchName("");
    setSearchDate("");

    // Obtener archivos del programa
    fetchFiles(prog.id);
  };

  // =========================
  // VOLVER A PROGRAMAS
  // =========================
  const handleBackToPrograms = () => {
    setSelectedProgram(null);
    setSelectedCategory(null);
    setSelectedSubcategory(null);
    setFiles([]);
    setSearchName("");
    setSearchDate("");
  };

  // =========================
  // ABRIR CATEGORÍA
  // =========================
  const handleOpenCategory = (category) => {
    setSelectedCategory(category);
    setSelectedSubcategory(null);

    setSearchName("");
    setSearchDate("");
  };

  // =========================
  // ABRIR SUBCATEGORÍA
  // =========================
  const handleOpenSubcategory = (subcategory) => {
    setSelectedSubcategory(subcategory);

    setSearchName("");
    setSearchDate("");
  };

  // =========================
  // VOLVER DENTRO DE ÁREA 1
  // =========================
  const handleBackArea1 = () => {
    if (selectedSubcategory !== null) {
      setSelectedSubcategory(null);
      return;
    }

    if (selectedCategory !== null) {
      setSelectedCategory(null);
      return;
    }

    handleBackToPrograms();
  };

  // =========================
  // CATEGORÍAS
  // =========================
  const categories = [
    {
      id: 1,
      name: "1. Jurídico"
    },
    {
      id: 2,
      name: "2. Financiero"
    },
    {
      id: 3,
      name: "3. Técnico"
    },
    {
      id: 4,
      name: "4. Administrativo"
    }
  ];

  // =========================
  // SUBCATEGORÍAS TÉCNICAS
  // =========================
  const subcategories = [
    {
      id: 1,
      name: "1. Planeación"
    },
    {
      id: 2,
      name: "2. Ejecución"
    },
    {
      id: 3,
      name: "3. Evaluación"
    }
  ];

  // =========================
  // DETERMINAR SI ESTAMOS
  // EN UNA CARPETA DE ARCHIVOS
  // =========================
  const isArea1 = selectedProgram
    ? Number(selectedProgram.area) === 1
    : false;

  const isFileLevel =
    !isArea1 ||
    (
      selectedCategory !== null &&
      selectedCategory !== 3
    ) ||
    (
      selectedCategory === 3 &&
      selectedSubcategory !== null
    );

  // =========================
  // OBTENER PREFIJO DE RUTA
  // =========================
  const getCurrentFolderPrefix = () => {
    if (!isArea1) {
      return null;
    }

    if (selectedCategory === null) {
      return null;
    }

    const categoryNames = {
      1: "1. Jurídico",
      2: "2. Financiero",
      3: "3. Técnico",
      4: "4. Administrativo"
    };

    let prefix =
      `uploads/program_files/1/${categoryNames[selectedCategory]}/`;

    if (selectedCategory === 3 && selectedSubcategory !== null) {
      const subcategoryNames = {
        1: "1. Planeación",
        2: "2. Ejecución",
        3: "3. Evaluación"
      };

      prefix += `${subcategoryNames[selectedSubcategory]}/`;
    }

    return prefix;
  };

  // =========================
  // FILTRAR ARCHIVOS
  // =========================
  const filteredFiles = files.filter((f) => {

    // Para área 1 solamente mostrar
    // archivos de la carpeta actual
    if (isArea1) {
      const currentPrefix = getCurrentFolderPrefix();

      if (
        currentPrefix &&
        !f.file_path.startsWith(currentPrefix)
      ) {
        return false;
      }
    }

    const matchName = f.name_file
      .toLowerCase()
      .includes(searchName.toLowerCase());

    const matchDate = searchDate
      ? f.created_at.startsWith(searchDate)
      : true;

    return matchName && matchDate;
  });

  // =========================
  // CREAR ARCHIVO
  // =========================
  const handleCreateFile = async () => {

    setFormError("");
    setFormSuccess("");

    if (!newFile.name || !newFile.file) {
      setFormError("Todos los campos son obligatorios");
      return;
    }

    // Para área 1 validar ubicación
    if (isArea1 && selectedCategory === null) {
      setFormError("Debe seleccionar una carpeta");
      return;
    }

    if (
      isArea1 &&
      selectedCategory === 3 &&
      selectedSubcategory === null
    ) {
      setFormError("Debe seleccionar una subcarpeta técnica");
      return;
    }

    try {

      const formData = new FormData();

      formData.append(
        "program",
        selectedProgram.id
      );

      formData.append(
        "name",
        newFile.name
      );

      formData.append(
        "file",
        newFile.file
      );

      // ==========================================
      // SOLO ÁREA 1
      // ==========================================
      if (isArea1) {

        formData.append(
          "category",
          selectedCategory
        );

        // Solo Técnico necesita subcategory
        if (
          selectedCategory === 3 &&
          selectedSubcategory !== null
        ) {
          formData.append(
            "subcategory",
            selectedSubcategory
          );
        }
      }

      const response = await fetch(
        ENDPOINTS.create_program_file,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          },
          body: formData
        }
      );

      const data = await response.json();

      if (!data.success) {
        setFormError(data.message);
        return;
      }

      setFormSuccess(
        "Archivo creado correctamente"
      );

      setNewFile({
        name: "",
        file: null
      });

      // Actualizar archivos
      fetchFiles(selectedProgram.id);

      setTimeout(() => {
        setShowModal(false);
        setFormSuccess("");
      }, 1000);

    } catch (error) {

      console.error(error);

      setFormError(
        "Error al conectar con el servidor"
      );
    }
  };

  // =========================
  // TITULO ACTUAL
  // =========================
  const getCurrentTitle = () => {

    if (!selectedProgram) {
      return "Programas";
    }

    if (!isArea1) {
      return selectedProgram.program_name;
    }

    if (selectedCategory === null) {
      return selectedProgram.program_name;
    }

    const category = categories.find(
      (c) => c.id === selectedCategory
    );

    if (
      selectedCategory === 3 &&
      selectedSubcategory !== null
    ) {

      const subcategory = subcategories.find(
        (s) => s.id === selectedSubcategory
      );

      return `${category?.name} / ${subcategory?.name}`;
    }

    return category?.name || selectedProgram.program_name;
  };

  return (
    <div className="container mt-4 p-4">

      {/* ========================= */}
      {/* LISTA DE PROGRAMAS */}
      {/* ========================= */}

      {!selectedProgram && (
        <>
          <h3 className="mb-4">
            Programas
          </h3>

          <div className="row mb-4">
            <div className="col-md-6">

              <input
                type="text"
                className="form-control"
                placeholder="Buscar documentos por programa..."
                value={searchProgram}
                onChange={(e) =>
                  setSearchProgram(e.target.value)
                }
              />

            </div>
          </div>

          <div className="row">

            {programasBusqueda.map((prog) => (

              <div
                key={prog.id}
                className="col-md-3 mb-4"
              >

                <div
                  className="card shadow-sm p-3 text-center"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleOpenProgram(prog)
                  }
                >

                  <div style={{ fontSize: "40px" }}>
                    📁
                  </div>

                  <strong>
                    {prog.program_name}
                  </strong>

                  <small className="text-muted">
                    {prog.area_name}
                  </small>

                </div>

              </div>

            ))}

          </div>
        </>
      )}

      {/* ========================= */}
      {/* VISTA INTERNA */}
      {/* ========================= */}

      {selectedProgram && (
        <>

          {/* HEADER */}

          <div className="position-relative d-flex align-items-center mb-4">

            <button
              className="btn btn-outline-purple"
              onClick={handleBackArea1}
            >
              <i className="bi bi-arrow-left"></i>
            </button>

            <h4 className="position-absolute start-50 translate-middle-x mb-0">
              📁 {getCurrentTitle()}
            </h4>

            {/* CREAR ARCHIVO */}
            {isFileLevel && (
              <button
                className="btn btn-outline-pink ms-auto"
                onClick={() => {
                  setFormError("");
                  setFormSuccess("");
                  setShowModal(true);
                }}
              >
                <i className="bi bi-plus me-2"></i>
                Crear archivo
              </button>
            )}

          </div>

          {/* ========================= */}
          {/* ÁREA 1 - CATEGORÍAS */}
          {/* ========================= */}

          {isArea1 &&
            selectedCategory === null && (

              <div className="row">

                {categories.map((category) => (

                  <div
                    key={category.id}
                    className="col-md-3 mb-4"
                  >

                    <div
                      className="card shadow-sm p-4 text-center"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleOpenCategory(
                          category.id
                        )
                      }
                    >

                      <div
                        style={{
                          fontSize: "50px"
                        }}
                      >
                        📁
                      </div>

                      <strong>
                        {category.name}
                      </strong>

                    </div>

                  </div>

                ))}

              </div>

            )}

          {/* ========================= */}
          {/* ÁREA 1 - TÉCNICO */}
          {/* ========================= */}

          {isArea1 &&
            selectedCategory === 3 &&
            selectedSubcategory === null && (

              <div className="row">

                {subcategories.map(
                  (subcategory) => (

                    <div
                      key={subcategory.id}
                      className="col-md-4 mb-4"
                    >

                      <div
                        className="card shadow-sm p-4 text-center"
                        style={{
                          cursor: "pointer"
                        }}
                        onClick={() =>
                          handleOpenSubcategory(
                            subcategory.id
                          )
                        }
                      >

                        <div
                          style={{
                            fontSize: "50px"
                          }}
                        >
                          📁
                        </div>

                        <strong>
                          {subcategory.name}
                        </strong>

                      </div>

                    </div>

                  )
                )}

              </div>

            )}

          {/* ========================= */}
          {/* ARCHIVOS */}
          {/* ========================= */}

          {isFileLevel && (

            <>

              {/* FILTROS */}

              <div className="row mb-3">

                <div className="col-md-6">

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Buscar por nombre..."
                    value={searchName}
                    onChange={(e) =>
                      setSearchName(
                        e.target.value
                      )
                    }
                  />

                </div>

                <div className="col-md-6">

                  <input
                    type="month"
                    className="form-control"
                    value={searchDate}
                    onChange={(e) =>
                      setSearchDate(
                        e.target.value
                      )
                    }
                  />

                </div>

              </div>

              {/* LISTA */}

              <ul className="list-group mt-4">

                {filteredFiles.length > 0 ? (

                  filteredFiles.map((f, i) => {

                    const fileUrl =
                      `${API_BASE_URL_DOCS}${f.file_path}`;

                    return (

                      <li
                        key={i}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >

                        <div>

                          <i className="bi bi-file-earmark me-2"></i>

                          <strong>
                            {f.name_file}
                          </strong>

                          <br />

                          <small className="text-muted">
                            {f.created_at}
                          </small>

                        </div>

                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-sm btn-outline-pink"
                        >
                          Ver
                        </a>

                      </li>

                    );

                  })

                ) : (

                  <li className="list-group-item text-center text-muted py-4">

                    <i className="bi bi-folder-x me-2"></i>

                    No hay archivos

                  </li>

                )}

              </ul>

            </>

          )}

        </>
      )}

      {/* ========================= */}
      {/* MODAL */}
      {/* ========================= */}

      {showModal && (

        <div className="modal show d-block">

          <div className="modal-dialog">

            <div className="modal-content">

              <div className="modal-header">

                <h5>
                  Crear Archivo
                </h5>

                <button
                  className="btn-close"
                  onClick={() =>
                    setShowModal(false)
                  }
                />

              </div>

              <div className="modal-body">

                {formError && (
                  <div className="alert alert-danger">
                    {formError}
                  </div>
                )}

                {formSuccess && (
                  <div className="alert alert-success">
                    {formSuccess}
                  </div>
                )}

                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Nombre del archivo"
                  value={newFile.name}
                  onChange={(e) =>
                    setNewFile({
                      ...newFile,
                      name: e.target.value
                    })
                  }
                />

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) =>
                    setNewFile({
                      ...newFile,
                      file: e.target.files[0]
                    })
                  }
                />

              </div>

              <div className="modal-footer">

                <button
                  className="btn btn-outline-secondary"
                  onClick={() =>
                    setShowModal(false)
                  }
                >
                  Cancelar
                </button>

                <button
                  className="btn btn-outline-pink"
                  onClick={handleCreateFile}
                >
                  Guardar
                </button>

              </div>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

export default ProgramFiles;